(function (app) {

    app.provider("tenantUserCapacityApi",
        [
            function () {
                this.$get = [
                    "crmApiGateway", function (crmApiGateway) {
                        var service = {};

                        service.getById = function (tenantUserCapacityId) {
                            return crmApiGateway.get("/TenantUserCapacity/" + tenantUserCapacityId);
                        }

                        service.getAll = function () {
                            return crmApiGateway.getArray("/TenantUserCapacity/");
                        }
                        
                        service.updateCapacity = function (tenantUserCapacityId, tenantUserCapacity) {
                            return crmApiGateway.put("/TenantUserCapacity/" + tenantUserCapacityId, tenantUserCapacity);
                        };

                        service.updateExpiration = function(tenantUserCapacityId, tenantUserCapacity) {
                            return crmApiGateway.put("/TenantUserCapacity/" + tenantUserCapacityId, tenantUserCapacity);
                        }

                        service.create = function (tenantUserCapacity) {
                            return crmApiGateway.post("/TenantUserCapacity", tenantUserCapacity);
                        };

                        return service;
                    }
                ];
            }
        ]);

})(window.app); //jshint ignore:line